// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.

require("@rails/ujs").start()
require("turbolinks").start()
require("@rails/activestorage").start()
require("channels")
require("trix")
require("@rails/actiontext")

import "bootstrap"
import '../stylesheets/application'
import "controllers"

import $ from 'jquery';
global.$ = jQuery;

document.addEventListener("turbolinks:load", () => {
	$.fn.render_form_errors = function(model_name, errors) {
	  var form;
	  form = this;
	  this.clear_form_errors();
	  return $.each(errors, function(field, messages) {
	    var input;
	    input = form.find('input, select, textarea').filter(function() {
	      var name;
	      name = $(this).attr('name');
	      if (name) {
	        return name.match(new RegExp(model_name + '\\[' + field + '\\(?'));
	      }
	    });
	    input.closest('.form-group').addClass('has-error');
	    return input.parent().append('<span class="help-block">' + $.map(messages, function(m) {
	      return m.charAt(0).toUpperCase() + m.slice(1);
	    }).join('<br />') + '</span>');
	  });
	};

	$.fn.clear_form_errors = function() {
	  this.find('.form-group').removeClass('has-error');
	  return this.find('span.help-block').remove();
	};

	$.fn.clear_form_fields = function() {
	  return this.find(':input', '#myform').not(':button, :submit, :reset, :hidden').val('').removeAttr('checked').removeAttr('selected');
	};
})

// Uncomment to copy all static images under ../images to the output folder and reference
// them with the image_pack_tag helper in views (e.g <%= image_pack_tag 'rails.png' %>)
// or the `imagePath` JavaScript helper below.
//
// const images = require.context('../images', true)
// const imagePath = (name) => images(name, true)
